/**
 * Shared defaults for shipping estimates — Live Calculator (admin) and Excel exports.
 * Book $19.50, CD $24.50; weights match export simulator assumptions.
 */

export const ESTIMATE_BOOK_KG = 0.35;
export const ESTIMATE_CD_KG = 0.12;
export const ESTIMATE_BOOK_PRICE = 19.50;
export const ESTIMATE_CD_PRICE = 24.50;

export function estimateCartWeightKg(bookQty, cdQty, bookKg = ESTIMATE_BOOK_KG, cdKg = ESTIMATE_CD_KG) {
  return +(bookQty * bookKg + cdQty * cdKg).toFixed(3);
}

export function estimateCartMerchandise(bookQty, cdQty, bookPrice = ESTIMATE_BOOK_PRICE, cdPrice = ESTIMATE_CD_PRICE) {
  return bookQty * bookPrice + cdQty * cdPrice;
}
